export const createObjectURLWithRef = (type, bytes, ref) => {
    const objectURL = URL.createObjectURL(new Blob([bytes], {
        type,
    }));
    ref.current = objectURL;
    return objectURL;
};
